import { render, staticRenderFns } from "./DeleteSensor.vue?vue&type=template&id=bbf37002&"
import script from "./DeleteSensor.vue?vue&type=script&lang=js&"
export * from "./DeleteSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports